module.exports = __webpack_public_path__ + "img/basic-version.584425f9.png";